import React from 'react';
import ReactDOM from 'react-dom';
import { ensureBrowserSession } from './_lib/browserSession';
// import { BrowserRouter as Router } from "react-router-dom";
import './index.css';
import App from './App';
// import registerServiceWorker from './registerServiceWorker';
import * as Sentry from "@sentry/react";

const sentryDsn = process.env.REACT_APP_SENTRY_DSN;

Sentry.init({
  dsn: sentryDsn,
  enabled: Boolean(sentryDsn),
  sendDefaultPii: false,
  beforeSend(event) {
    delete event.user;
    if (event.request) {
      delete event.request.cookies;
      delete event.request.data;
      delete event.request.headers;
    }
    return event;
  },
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.browserProfilingIntegration(),
    Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }),
  ],
  // Termly, the Facebook pixel and GTM load from other origins without a
  // crossorigin attribute, so anything they throw reaches us as a bare
  // "Script error." with no file, line or stack. Reporting it reveals nothing
  // and buries real issues. Adding crossorigin="anonymous" to those tags would
  // unmask them, but a provider that omits Access-Control-Allow-Origin would
  // then fail to load at all — not a trade worth making for a consent blocker.
  ignoreErrors: ["Script error.", "Script error"],
  tracesSampleRate: 0.1,
  tracePropagationTargets: ["localhost", /^https:\/\/host.crewmatesapp\.com/,/^https:\/\/devhost.crewmatesapp\.com/],
  profilesSampleRate: 0.01,
  replaysSessionSampleRate: 0.01,
  replaysOnErrorSampleRate: 0.1,
});
ensureBrowserSession().finally(() => {
  ReactDOM.render(<App />, document.getElementById('root'));
});
// registerServiceWorker();
